import { render, staticRenderFns } from "./CampoAdicionalSql.vue?vue&type=template&id=4800c998&scoped=true"
import script from "./CampoAdicionalSql.vue?vue&type=script&lang=js"
export * from "./CampoAdicionalSql.vue?vue&type=script&lang=js"
import style0 from "./CampoAdicionalSql.vue?vue&type=style&index=0&id=4800c998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4800c998",
  null
  
)

export default component.exports